import { Form, Gap, P, Toggle } from '@salecycle/ui-component-library';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useNewRoleDispatch, useNewRoleState } from '../context/useNewRoleContext';
import { updateRolePermissionAction } from '../actions/updateRolePermissionAction';

export const NewRoleSidebar: React.FC = () => {
  const { t } = useTranslation();
  const { permissions } = useNewRoleState();
  const dispatch = useNewRoleDispatch();
  const permissionToggles: Array<{ name: string; isSelected: boolean }> = [];
  const allPermissionsActive = Object.values(permissions).every(val => !!val);
  const toggleAllPermissions = (isSelected: boolean) =>
    dispatch({ type: 'UPDATE_ALL_ROLE_PERMISSIONS', payload: { isSelected } });
  const changeSelection = (name: string, checked: boolean) =>
    updateRolePermissionAction(name, checked, permissions, dispatch);

  for (const key in permissions) {
    permissionToggles.push({
      name: key,
      isSelected: permissions[key],
    });
  }

  return (
    <>
      <P>{t('newRole.roleSetup.sidebar.description')}</P>
      <Gap top={30} />

      <Form>
        <Toggle
          label={t('newRole.roleSetup.sidebar.components.selectAllToggle.label')}
          ariaLabel={t('newRole.roleSetup.sidebar.components.selectAllToggle.ariaLabel')}
          onChange={toggleAllPermissions}
          checked={allPermissionsActive}
        />

        {permissionToggles
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map(option => (
            <Fragment key={`${option.name}-toggle`}>
              <Gap top={15} />
              <Toggle
                label={t(`newRole.roleSetup.permissionsLabels.${option.name}`)}
                checked={permissions[option.name]}
                ariaLabel={t(`newRole.roleSetup.permissionsLabelsAriaLabels.${option.name}`, {
                  optionName: option.name,
                })}
                onChange={isOn => changeSelection(option.name, isOn)}
                margin={false}
              />
            </Fragment>
          ))}
      </Form>
    </>
  );
};
